import { IConfiguration } from 'store/configuration/types';

const SCREENS = ['ticket', 'contact', 'project_ticket'] as const;

type PodScreen = (typeof SCREENS)[number];

export const getPodConfiguration = (psaId: number, searchParams: URLSearchParams): IConfiguration => {
  const entityId = searchParams.get('ticketId') ?? searchParams.get('entityid');
  const screenType = searchParams.get('screen');
  const screen: PodScreen = SCREENS.includes(screenType as PodScreen)
    ? (screenType as PodScreen)
    : 'ticket';

  return {
    psaId,
    ticketId: entityId?.replace(/^0+/, '') ?? undefined,
    screen,
    contactId: screen === 'contact' ? (entityId ?? undefined) : undefined,
  };
};
